import { render, staticRenderFns } from "./NuovoOrdine.vue?vue&type=template&id=dffbc72c&"
import script from "./NuovoOrdine.vue?vue&type=script&lang=js&"
export * from "./NuovoOrdine.vue?vue&type=script&lang=js&"
import style0 from "./NuovoOrdine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports